import { render, staticRenderFns } from "./KaiSecondaryCtaButton.vue?vue&type=template&id=0e9e2860&scoped=true&"
var script = {}
import style0 from "./KaiSecondaryCtaButton.vue?vue&type=style&index=0&id=0e9e2860&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9e2860",
  null
  
)

export default component.exports